import { render, staticRenderFns } from "./SystemForm.vue?vue&type=template&id=55e4f702&"
import script from "./SystemForm.vue?vue&type=script&lang=js&"
export * from "./SystemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports